import { IEventFeedResponse } from "@finbackoffice/websocket-client";
import { FC, useCallback, useContext } from "react";
import { Url } from "next/dist/shared/lib/router/router";
import { useRouter } from "next/router";
import ActiveLink from "components/base/active-link/ActiveLink";
import FadeInAnimation from "components/base/fade-in/FadeInAnimation";
import Loading from "components/base/loading/Loading";
import { useDate, DEFAULT_DATE_FORMAT } from "hooks";
import { RouteNames } from "utils/constants";
import { InitialDataContext } from "contexts";
import styles from "../../live-game/game-selector/layouts/categories/categories.module.sass";
import { PrematchGameSelectorContext } from "./PrematchGameSelector";
type IProps = {
    closeSelector: () => void;
    gamesData: IEventFeedResponse[];
    loading: boolean;
};

const Games: FC<IProps> = ({ closeSelector, gamesData, loading }) => {
    const router = useRouter();
    const { variant } = useContext(PrematchGameSelectorContext);
    const { setActiveSportGame } = useContext(InitialDataContext);
    const { formatDate } = useDate();

    const getGameHref = useCallback(
        (gameData: IEventFeedResponse) => {
            let gameHref: Url;
            if (variant === "modal") {
                gameHref = {
                    query: {
                        ...router.query,
                        gameId: gameData.id,
                    },
                };
            } else {
                gameHref = `/${RouteNames.SPORT}/${RouteNames.PREMATCH}/${gameData.sport_slug}/${gameData.category_id}/${gameData.tournament_id}/${gameData.id}`;
            }

            return gameHref;
        },
        [router.query, variant],
    );

    const handleGameClick = useCallback(
        (gameId: string) => {
            if (variant === "modal") {
                setActiveSportGame((state) => ({ ...state, gameId }));
            }
        },
        [setActiveSportGame, variant],
    );

    const renderGameLink = useCallback(
        (gameData: IEventFeedResponse) => {
            return (
                <li key={gameData.id}>
                    <ActiveLink
                        onClick={() => handleGameClick(gameData.id.toString())}
                        href={getGameHref(gameData)}
                        includes={gameData.id.toString()}
                        activeClassName={styles.selected}
                        className={styles.game}>
                        <div className={styles.teamNames}>
                            <span>
                                {gameData.home_team?.name}
                                {" vs "}
                                {gameData.away_team?.name}
                            </span>
                            <span>
                                {gameData.scheduled_at &&
                                    formatDate(
                                        new Date(gameData.scheduled_at),
                                        `${DEFAULT_DATE_FORMAT} HH:mm`,
                                    )}
                            </span>
                        </div>
                    </ActiveLink>
                </li>
            );
        },
        [formatDate, getGameHref, handleGameClick],
    );

    if (loading) {
        return <Loading />;
    }

    return (
        gamesData.length !== 0 && (
            <>
                <div className={styles.dropdownBackdrop} onClick={() => closeSelector()} />
                <FadeInAnimation>
                    <ul className={styles.dropdown}>{gamesData.map(renderGameLink)}</ul>
                </FadeInAnimation>
            </>
        )
    );
};

export default Games;
